module.exports = [{
      plugin: require('C:/Users/daniel/proyectos/grupoaristas/web2019/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-XXXXXXXX-X","anonymize":true},
    },{
      plugin: require('C:/Users/daniel/proyectos/grupoaristas/web2019/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
